import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  logo: {
    width: '200px',
  },
  title: {
    fontStyle: 'italic'
  }
})

const BusinessLogo = ({ classes, logoURL, title }) => {
  console.log("logoURL", logoURL)
  return(
    <div className={classes.root}>
      {logoURL &&
        <img className={classes.logo} src={logoURL} alt="logo" />
      }
      <Typography className={classes.title} variant="title">
        {title}
      </Typography>
    </div>
  );
};

const mapStateToProps = (state) => ({
  logoURL: state.businessState.logoURL,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(BusinessLogo);



// WEBPACK FOOTER //
// ./src/components/Logo/BusinessLogo.jsx